// export const yellow = '#FFC425'
export const primaryYellow = '#fcc33a'
export const primaryBlack = '#000000'
// export const secondaryGreen = '#48b596'
export const secondaryRed = '#ee3b63'
// export const secondaryOrange = '#f36f36'
// export const secondaryPurple = '#6158a6'
// export const secondaryBlue = '#3596d2'
export const button = '#ffffff'
export const newsEvents = '#ffffff'